/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientSidePathEndpointResponse
 */
export interface ClientSidePathEndpointResponse {
    /**
     * 
     * @type {string}
     * @memberof ClientSidePathEndpointResponse
     */
    clientSideUrl: string;
}

export function ClientSidePathEndpointResponseFromJSON(json: any): ClientSidePathEndpointResponse {
    return ClientSidePathEndpointResponseFromJSONTyped(json, false);
}

export function ClientSidePathEndpointResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientSidePathEndpointResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clientSideUrl': json['client_side_url'],
    };
}

export function ClientSidePathEndpointResponseToJSON(value?: ClientSidePathEndpointResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'client_side_url': value.clientSideUrl,
    };
}


